import { render, staticRenderFns } from "./OrganizationalPreferencesPane.vue?vue&type=template&id=657444e1&"
import script from "./OrganizationalPreferencesPane.vue?vue&type=script&lang=ts&"
export * from "./OrganizationalPreferencesPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports